import { render, staticRenderFns } from "./ConfirmSubmitRejectProvider.vue?vue&type=template&id=15eb28d4&scoped=true&"
import script from "./ConfirmSubmitRejectProvider.vue?vue&type=script&lang=ts&"
export * from "./ConfirmSubmitRejectProvider.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmSubmitRejectProvider.vue?vue&type=style&index=0&id=15eb28d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15eb28d4",
  null
  
)

export default component.exports